import { render, staticRenderFns } from "./SignupIndex.vue?vue&type=template&id=f53a04b0&scoped=true&"
import script from "./SignupIndex.vue?vue&type=script&lang=js&"
export * from "./SignupIndex.vue?vue&type=script&lang=js&"
import style0 from "./SignupIndex.vue?vue&type=style&index=0&id=f53a04b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f53a04b0",
  null
  
)

export default component.exports